export const SECURITY_ROLES =
    {
      CLOUD_ADMIN: 'CloudAdmin',
      COMPANY_ADMIN: 'CompanyAdmin',
      USER: 'User',
      POWER_USER: 'PowerUser',
      ANY_AUTHORIZED_USER: '*',
      SHARED_USER: 'SharedUser'
    };
